<div class="container-fluid webView" style="padding: 15px">
    <!--Header-->
    <div class="col-md-12 col-sm-12 col-xs-12 disFlx pad0">
        <div class="col-md-8 col-sm-8 col-xs-8 disFlx pad0">
            <h3 style="margin-top:0px;" class="lblHeader newHeader">{{itemSummaryData.ItemName}}</h3>
        </div>
        <div *ngIf="show.scrollBtns" class="col-md-4 col-sm-4 col-xs-4 disFlx pad0" style="justify-content: end;">
            <span class="btn orangeButton fontSizeHead" style=" font-size: 13px !important; cursor: pointer; border-radius: 3px; margin-left: 5px;" (click)="scrollToDiv('soDiv')">
                SO
            </span>
            <span class="btn orangeButton fontSizeHead" style=" font-size: 13px !important; cursor: pointer; border-radius: 3px; margin-left: 5px;" (click)="scrollToDiv('poDiv')">
                PO
            </span>
            <span class="btn orangeButton fontSizeHead" style=" font-size: 13px !important; cursor: pointer; border-radius: 3px; margin-left: 5px;" (click)="scrollToDiv('jobDiv')">
                Job
            </span>
            <span class="btn orangeButton fontSizeHead" style=" font-size: 13px !important; cursor: pointer; border-radius: 3px; margin-left: 5px;" (click)="scrollToDiv('storeDiv')">
                Stores
            </span>
            <span *ngIf="isBatchEnabled" class="btn orangeButton fontSizeHead" style=" font-size: 13px !important; cursor: pointer; border-radius: 3px; margin-left: 5px;" (click)="scrollToDiv('batchDiv')">
                Batches
            </span>
        </div>
    </div>

    <!-- Item Details Block -->
    <div class="col-md-12 col-sm-12 col-xs-12 disFlx pad0" style="margin-top: 10px; gap: 5px;">
        <span class="orngLabel" *ngIf="itemSummaryData.categoryName != ''">
            Category  <span style="font-weight: 600;">{{itemSummaryData.categoryName}}</span>
        </span>
        <span class="orngLabel" *ngIf="itemSummaryData.subCategoryName != ''">
            Subcategory  <span style="font-weight: 600;">{{itemSummaryData.subCategoryName}}</span>
        </span>
        <span class="orngLabel">
            Min Qty.  <span style="font-weight: 600;">{{itemSummaryData.MinStockQty}} {{itemSummaryData.SKU}}</span>
        </span>
        <span class="orngLabel">
            Lead Time <span style="font-weight: 600;">{{itemSummaryData.LeadTime}} {{itemSummaryData.LeadTime == 1 ? 'day' : 'days'}}</span>
        </span>
    </div>

    <!-- Sales Orders Table -->
    <div id="soDiv" class="col-md-12 col-sm-12 col-xs-12 pad0 bzMatTbl" style="margin-top: 15px; padding: 15px;">
        <div class="col-md-12 col-sm-12 col-xs-12 disFlx pad0">
            <div class="col-md-6 col-sm-6 col-xs-6 pad0">
                <span class="lblHeader newHeader" style="font-size: 20px !important;">
                  Sales Orders <span *ngIf="userRights.SOViewTypeID > 0">({{soDataSource.data.length}})</span>
                </span>
            </div>
            <div *ngIf="userRights.SOViewTypeID > 0" class="col-md-6 col-sm-6 col-xs-6 pad0" style="text-align: end;">
              <div *ngIf="show.SODetailLabels" style="display: inline;">
                <span class="orngLabel" *ngIf="total.SOItemQty > 0"> 
                  Total Qty. <span style="font-weight: 600;">{{total.SOItemQty}}</span>
                </span>
                <span class="orngLabel" style="margin-left: 5px;" *ngIf="total.SOAmt > 0">
                    Total Amt. &#8377; <span style="font-weight: 600;">{{total.SOAmt | lacFormat : 1}}</span>
                </span>
              </div>
              <a class="btn orangeButton fontSizeHead" href="/main.html#/orders" target="{{isWeb ? '_blank' : '_self'}}" style="font-size: 13px !important; cursor: pointer; border-radius: 3px; margin-left: 5px;" title="Manage">
                <span style="vertical-align: middle;"><i class="fa fa-list"></i> Manage</span>
              </a>
              <a *ngIf="userRights.SOEntry" class="btn orangeButton fontSizeHead" href="/main.html#/DocBuilder?isN=1&Type=Sales%20Order" target="{{isWeb ? '_blank' : '_self'}}" style="font-size: 13px !important; cursor: pointer; border-radius: 3px; margin-left: 5px;"
                title="Add">
                <i class="zmdi zmdi-plus" style="font-size: 15px; vertical-align: middle;"></i>
              </a>
            </div>            
        </div>
        <div *ngIf="soDataSource.data.length == 0 && userRights.SOViewTypeID > 0" class="col-md-12 col-sm-12 col-xs-12 pad0" style="padding: 10px 0px 0px 0px;">
          <span class="infoBadge" style="font-size: 13px !important; display: inline-flex; background-color: #f1f1f0; border: none; color: inherit; padding: 6px; border-radius: 3px;">No Sales Orders Found</span>
        </div>
        <div *ngIf="userRights.SOViewTypeID == 0" class="col-md-12 col-sm-12 col-xs-12 pad0" style="padding: 10px 0px 0px 0px;">
          <span class="infoBadge" style="font-size: 13px !important; display: inline-flex; background-color: #f1f1f0; border: none; color: inherit; padding: 6px; border-radius: 3px;">Please contact your system administrator to upgrade your account.</span>
        </div>
        <div class="soTable" *ngIf="soDataSource.data.length > 0 && userRights.SOViewTypeID > 0">
            <table #soSort = "matSort" mat-table [dataSource]="soDataSource" matSort style="border-radius: 3px; padding-left: 16px !important; padding: 0px;">
              <ng-container matColumnDef="BuyerCompName">
                <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header style="padding-top: 10px; padding-left: 8px; padding-right: 8px;">
                  <label style="font-size: 13px;">Customer</label>
                </th>
                <td mat-cell *matCellDef="let element"> {{(element.BuyerCompName ? element.BuyerCompName : '-')}} </td>
              </ng-container>
    
              <ng-container matColumnDef="OrderNo">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                    style="text-align: right; font-size: 13px; cursor: pointer;padding-top: 10px; padding-left: 8px; padding-right: 8px;">
                    <label style="cursor: pointer;font-size: 13px;">Order No.</label>
                </th>
                <td mat-cell *matCellDef="let element">
                    <div style="padding-right: 11px;">
                      {{element.OrderNo ? element.OrderNo : '-'}} </div>
                </td>
              </ng-container>
              
              <ng-container matColumnDef="CstrPONo">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                    style="text-align: right; font-size: 13px; cursor: pointer; padding-top: 10px; padding-left: 8px; padding-right: 8px;">
                    <label style="cursor: pointer;font-size: 13px;">Cstr P.O.</label>
                </th>
                <td mat-cell *matCellDef="let element">
                    <div style="padding-right: 11px;">
                      {{element.CstrPONo ? element.CstrPONo : '-'}} </div>
                </td>
              </ng-container>
    
              <ng-container matColumnDef="OrderDate">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                    style="text-align: right; font-size: 13px; cursor: pointer; padding-top: 10px; padding-left: 8px; padding-right: 8px;">
                    <label style="cursor: pointer;font-size: 13px;">Order Date</label>
                </th>
                <td mat-cell *matCellDef="let element">
                    <div style="padding-right: 11px;">
                      {{element.OrderDate | todayTommorow}}</div>
                </td>
              </ng-container>

              <ng-container matColumnDef="DueDT">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                    style="text-align: right; font-size: 13px; cursor: pointer; padding-top: 10px; padding-left: 8px; padding-right: 8px;">
                    <label style="cursor: pointer;font-size: 13px;">Due Date</label>
                </th>
                <td mat-cell *matCellDef="let element">
                    <div style="padding-right: 11px;">
                      {{element.DueDT | todayTommorow}}</div>
                </td>
              </ng-container>
    
              <ng-container matColumnDef="OrderQty">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                    style="text-align: right; font-size: 13px; cursor: pointer; padding-top: 10px; padding-left: 8px;">
                    <label style="cursor: pointer;font-size: 13px;">Qty</label>
                </th>
                <td mat-cell *matCellDef="let element">
                    <div style="text-align: right; padding-right: 11px;">
                      {{element.OrderQty}} </div>
                </td>
              </ng-container>
    
              <ng-container matColumnDef="SKU">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                    style="text-align: right; font-size: 13px; cursor: pointer; padding-top: 10px; padding-left: 8px; padding-right: 8px;">
                    <label style="cursor: pointer;font-size: 13px;">Unit</label>
                </th>
                <td mat-cell *matCellDef="let element">
                    <div style="padding-right: 11px;">
                      {{element.SKU}} </div>
                </td>
              </ng-container>
    
              <ng-container matColumnDef="GrandTotal">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                    style="text-align: center; font-size: 13px; cursor: pointer; padding-top: 10px; padding-left: 8px; padding-right: 0px;">
                    <label style="cursor: pointer;font-size: 13px;">Total</label>
                </th>
                <td mat-cell *matCellDef="let element">
                    <div style="text-align: right; padding-right: 11px;">
                      {{(element.GrandTotal ? element.GrandTotal : '-') | lacFormat : 1}}</div>
                </td>
              </ng-container>  
          
              <tr mat-header-row *matHeaderRowDef="soDisplayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: soDisplayedColumns;"></tr>
            </table>
        </div>
    </div>

    <!-- Purchase Orders Table -->
    <div id="poDiv" class="col-md-12 col-sm-12 col-xs-12 pad0 bzMatTbl" style="margin-top: 15px; padding: 15px;">
        <div class="col-md-12 col-sm-12 col-xs-12 disFlx pad0">
            <div class="col-md-6 col-sm-6 col-xs-6 pad0">
                <span class="lblHeader newHeader" style="font-size: 20px !important;">
                  Purchase Orders <span *ngIf="userRights.POView">({{poDataSource.data.length}})</span>
                </span>
            </div>
            <div *ngIf="userRights.POView" class="col-md-6 col-sm-6 col-xs-6 pad0" style="text-align: end;">
              <div *ngIf="show.PODetailLabels" style="display: inline;">
                <span class="orngLabel" *ngIf="total.POItemQty > 0">
                  Total Qty. <span style="font-weight: 600;">{{total.POItemQty}}</span>
                </span>
                <span class="orngLabel" style="margin-left: 5px;" *ngIf="total.POAmt > 0">
                    Total Amt. &#8377; <span style="font-weight: 600;">{{total.POAmt | lacFormat : 1}}</span>
                </span>
              </div>
              <a class="btn orangeButton fontSizeHead" href="/main.html#/Docs?M=8" target="{{isWeb ? '_blank' : '_self'}}" style="font-size: 13px !important; cursor: pointer; border-radius: 3px; margin-left: 5px;"
                title="Manage">
                <span style="vertical-align: middle;"><i class="fa fa-list"></i> Manage</span>
              </a>
              <a *ngIf="userRights.POEntry" class="btn orangeButton fontSizeHead" href="/main.html#/DocBuilder?isN=1&Type=Purchase%20Order" target="{{isWeb ? '_blank' : '_self'}}" style="font-size: 13px !important; cursor: pointer; border-radius: 3px; margin-left: 5px;" title="Add" >
                <i class="zmdi zmdi-plus" style="font-size: 15px; vertical-align: middle;"></i>
              </a>
            </div>            
        </div>
        <div *ngIf="poDataSource.data.length == 0 && userRights.POView" class="col-md-12 col-sm-12 col-xs-12 pad0" style="padding: 10px 0px 0px 0px;">
          <span class="infoBadge" style="font-size: 13px !important; display: inline-flex; background-color: #f1f1f0; border: none; color: inherit; padding: 6px; border-radius: 3px;">No Purchase Orders Found</span>
        </div>
        <div *ngIf="!userRights.POView" class="col-md-12 col-sm-12 col-xs-12 pad0" style="padding: 10px 0px 0px 0px;">
          <span class="infoBadge" style="font-size: 13px !important; display: inline-flex; background-color: #f1f1f0; border: none; color: inherit; padding: 6px; border-radius: 3px;">Please contact your system administrator to upgrade your account.</span>
        </div>
        <div class="poTable" *ngIf="poDataSource.data.length > 0 && userRights.POView">
            <table #poSort = "matSort" mat-table [dataSource]="poDataSource" matSort style="border-radius: 3px; padding-left: 16px !important; padding: 0px;">
              <ng-container matColumnDef="SellerAgencyName">
                <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header style="padding-top: 10px; padding-bottom: 5px; padding-left: 8px;">
                  <label style="font-size: 13px;">Supplier</label>
                </th>
                <td mat-cell *matCellDef="let element"> {{element.SellerAgencyName ? element.SellerAgencyName : '-'}} </td>
              </ng-container>

              <ng-container matColumnDef="BillTo">
                <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header style="padding-top: 10px; padding-bottom: 5px; padding-left: 8px;">
                  <label style="font-size: 13px;">Bill To</label>
                </th>
                <td mat-cell *matCellDef="let element"> {{element.BillTo ? element.BillTo : '-'}} </td>
              </ng-container>
    
              <ng-container matColumnDef="DocNo">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: right; font-size: 13px; cursor: pointer; padding-left: 26px; padding-top: 10px; padding-bottom: 5px; padding-left: 8px;">
                    <label style="cursor: pointer;font-size: 13px;">Order No.</label>
                </th>
                <td mat-cell *matCellDef="let element">
                    <div style="padding-right: 11px;">
                      {{element.DocNo ? element.DocNo : '-'}} </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="ItemQty">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: right; font-size: 13px; cursor: pointer; padding-left: 13px; padding-top: 10px; padding-bottom: 5px; padding-left: 8px;">
                    <label style="cursor: pointer;font-size: 13px;">Qty</label>
                </th>
                <td mat-cell *matCellDef="let element">
                    <div style="text-align: right; padding-right: 11px;">
                      {{element.ItemQty}} </div>
                </td>
              </ng-container>
    
              <ng-container matColumnDef="SKU">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: right; font-size: 13px; cursor: pointer; padding-left: 8px; padding-top: 10px; padding-bottom: 5px; padding-left: 8px;">
                    <label style="cursor: pointer;font-size: 13px;">Unit</label>
                </th>
                <td mat-cell *matCellDef="let element">
                    <div style="padding-right: 11px;">
                      {{element.SKU}} </div>
                </td>
              </ng-container>
              
              <ng-container matColumnDef="DocDate">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: right; font-size: 13px; cursor: pointer; padding-left: 8px; padding-top: 10px; padding-bottom: 5px;">
                    <label style="cursor: pointer;font-size: 13px;">Order Date</label>
                </th>
                <td mat-cell *matCellDef="let element">
                    <div style="padding-right: 11px;">
                      {{element.DocDate | todayTommorow}} </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="DueDT">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: right; font-size: 13px; cursor: pointer; padding-left: 8px; padding-top: 10px; padding-bottom: 5px;">
                    <label style="cursor: pointer;font-size: 13px;">Due Date</label>
                </th>
                <td mat-cell *matCellDef="let element">
                    <div style="padding-right: 11px;">
                      {{element.DueDT | todayTommorow}} </div>
                </td>
              </ng-container>
    
              <ng-container matColumnDef="SubTotal">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: right; font-size: 13px; cursor: pointer; padding-left: 8px; padding-top: 10px; padding-bottom: 5px;">
                    <label style="cursor: pointer;font-size: 13px;">Taxable</label>
                </th>
                <td mat-cell *matCellDef="let element">
                    <div style="padding-right: 11px;">
                      {{(element.SubTotal ? element.SubTotal : '-') | lacFormat : 1}}</div>
                </td>
              </ng-container>
    
              <ng-container matColumnDef="GrandTotal">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: center; font-size: 13px; cursor: pointer; padding-left: 13px; padding-top: 10px; padding-bottom: 5px; padding-right: 0px;">
                    <label style="cursor: pointer;font-size: 13px;">Total</label>
                </th>
                <td mat-cell *matCellDef="let element">
                    <div style="text-align: right; padding-right: 11px;">
                      {{(element.GrandTotal ? element.GrandTotal : '-') | lacFormat : 1}}</div>
                </td>
              </ng-container>  
          
              <tr mat-header-row *matHeaderRowDef="poDisplayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: poDisplayedColumns;"></tr>
            </table>
        </div>
    </div>

     <!-- Job Table -->
     <div id="jobDiv" class="col-md-12 col-sm-12 col-xs-12 pad0 bzMatTbl" style="margin-top: 15px; padding: 15px;">
      <div class="col-md-12 col-sm-12 col-xs-12 disFlx pad0">
          <div class="col-md-6 col-sm-6 col-xs-6 pad0">
              <span class="lblHeader newHeader" style="font-size: 20px !important;">
                Production Jobs <span *ngIf="userRights.JobView">({{jobDataSource.data.length}})</span>
              </span>
          </div>   
          <div *ngIf="userRights.JobView" class="col-md-6 col-sm-6 col-xs-6 pad0" style="text-align: end;">
            <a class="btn orangeButton fontSizeHead" href="/ERP/ProductionList?p=1" target="{{isWeb ? '_blank' : '_self'}}" style="font-size: 13px !important; cursor: pointer; border-radius: 3px; margin-left: 5px;" title="Manage">
              <span style="vertical-align: middle;"><i class="fa fa-list"></i> Manage</span>
            </a>
            <a class="btn orangeButton fontSizeHead" href="/ERP/ProductionList?p=1" target="{{isWeb ? '_blank' : '_self'}}" style="font-size: 13px !important; cursor: pointer; border-radius: 3px; margin-left: 5px;" title="Add">
              <i class="zmdi zmdi-plus" style="font-size: 15px; vertical-align: middle;"></i>
            </a>
          </div> 
      </div>
      <div *ngIf="jobDataSource.data.length == 0 && userRights.JobView" class="col-md-12 col-sm-12 col-xs-12 pad0" style="padding: 10px 0px 0px 0px;">
        <span class="infoBadge" style="font-size: 13px !important; display: inline-flex; background-color: #f1f1f0; border: none; color: inherit; padding: 6px; border-radius: 3px;">No Production Jobs Found</span>
      </div>
      <div *ngIf="!userRights.JobView" class="col-md-12 col-sm-12 col-xs-12 pad0" style="padding: 10px 0px 0px 0px;">
        <span class="infoBadge" style="font-size: 13px !important; display: inline-flex; background-color: #f1f1f0; border: none; color: inherit; padding: 6px; border-radius: 3px;">Please contact your system administrator to upgrade your account.</span>
      </div>
      <div class="jobTable" *ngIf="jobDataSource.data.length > 0 && userRights.JobView">
          <table #jobSort="matSort" mat-table [dataSource]="jobDataSource" matSort style="border-radius: 3px; padding-left: 16px !important; padding: 0px;">
            <ng-container matColumnDef="JobNo">
              <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header style="padding-top: 10px; padding-bottom: 5px; padding-left: 8px;">
                <label style="font-size: 13px;">WIP No.</label>
              </th>
              <td mat-cell *matCellDef="let element"> {{element.JobNo ? element.JobNo : '-'}} </td>
            </ng-container>    

            <ng-container matColumnDef="CstrRelName">
              <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                  style="text-align: right; font-size: 13px; cursor: pointer; padding-left: 0px; padding-top: 10px; padding-bottom: 5px;  padding-left: 8px;">
                  <label style="cursor: pointer;font-size: 13px;">Customer</label>
              </th>
              <td mat-cell *matCellDef="let element"> {{element.CstrRelName ? element.CstrRelName : '-'}} </td>
            </ng-container>
  
            <ng-container matColumnDef="LaunchDT">
              <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                  style="text-align: right; font-size: 13px; cursor: pointer; padding-left: 0px; padding-top: 10px; padding-bottom: 5px; padding-left: 8px;">
                  <label style="cursor: pointer;font-size: 13px;">Launch</label>
              </th>
              <td mat-cell *matCellDef="let element"> {{element.LaunchDT ? (element.LaunchDT | todayTommorow) : '-'}} </td>
            </ng-container>

            <ng-container matColumnDef="TargetDT">
              <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                  style="text-align: right; font-size: 13px; cursor: pointer; padding-left: 0px; padding-top: 10px; padding-bottom: 5px; padding-left: 8px;">
                  <label style="cursor: pointer;font-size: 13px;">Target</label>
              </th>
              <td mat-cell *matCellDef="let element"> {{element.TargetDT ? (element.TargetDT | todayTommorow) : '-'}} </td>
            </ng-container>

            <ng-container matColumnDef="PndgQty">
              <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: right; font-size: 13px; cursor: pointer; padding-left: 0px; padding-top: 10px; padding-bottom: 5px; padding-left: 8px;">
                  <label style="cursor: pointer;font-size: 13px;">Qty</label>
              </th>
              <td mat-cell *matCellDef="let element" style="text-align: right;"> 
                <span style="padding-right: 11px;"> {{element.PndgQty > 0 ? element.PndgQty : '0'}} </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="SKU">
              <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: right; font-size: 13px; cursor: pointer; padding-left: 0px; padding-top: 10px; padding-bottom: 5px; padding-left: 8px;">
                  <label style="cursor: pointer;font-size: 13px;">Unit</label>
              </th>
              <td mat-cell *matCellDef="let element"> 
                <span style="padding-right: 11px;"> {{itemSummaryData.SKU}} </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="Stage">
              <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                  style="text-align: right; font-size: 13px; cursor: pointer; padding-left: 0px; padding-top: 10px; padding-bottom: 5px; padding-left: 8px;">
                  <label style="cursor: pointer;font-size: 13px;">Stage</label>
              </th>
              <td mat-cell *matCellDef="let element"> {{element.Stage ? element.Stage : '-'}} </td>
            </ng-container>
        
            <tr mat-header-row *matHeaderRowDef="jobDisplayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: jobDisplayedColumns;"></tr>
          </table>
      </div>
    </div>
    
    <div style="display: flex; column-gap: 10px;"> 
      <!-- Stores Info Table -->
      <div id="storeDiv" class="pad0 bzMatTbl" style="margin-top: 15px; padding: 15px;" [style.width]="isBatchEnabled ? '40%' : '100%'">
        <div class="col-md-12 col-sm-12 col-xs-12 disFlx pad0">
            <div class="col-md-10 col-sm-10 col-xs-10 pad0">
                <span class="lblHeader newHeader" style="font-size: 20px !important;">
                  Stores <span *ngIf="allStoreRights">({{storeDataSource.data.length}})</span>
                </span>
            </div>        
        </div>
        <div *ngIf="storeDataSource.data.length == 0 && allStoreRights" class="col-md-12 col-sm-12 col-xs-12 pad0" style="padding: 10px 0px 0px 0px;">
          <span class="infoBadge" style="font-size: 13px !important; display: inline-flex; background-color: #f1f1f0; border: none; color: inherit; padding: 6px; border-radius: 3px;">No Stores Found</span>
        </div>
        <div *ngIf="!allStoreRights" class="col-md-12 col-sm-12 col-xs-12 pad0" style="padding: 10px 0px 0px 0px;">
          <span class="infoBadge" style="font-size: 13px !important; display: inline-flex; background-color: #f1f1f0; border: none; color: inherit; padding: 6px; border-radius: 3px;">Please contact your system administrator to upgrade your account.</span>
        </div>
        <div class="storeTable" *ngIf="storeDataSource.data.length > 0 && allStoreRights">
            <table #storeSort="matSort"  mat-table [dataSource]="storeDataSource" matSort style="border-radius: 3px; padding-left: 16px !important; padding: 0px;" [style.width]="isBatchEnabled ? '100%' : '40%'">
              <ng-container matColumnDef="strName">
                <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header style="padding-top: 10px; padding-left: 8px; padding-bottom: 5px;">
                  <label style="font-size: 13px;">Store</label>
                </th>
                <td mat-cell *matCellDef="let element"> {{element.strName}} </td>
              </ng-container>
    
              <ng-container matColumnDef="strQty">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                    style="text-align: right; font-size: 13px; cursor: pointer; padding-top: 10px; padding-left: 8px; padding-bottom: 5px; padding-right: 0;">
                    <label style="cursor: pointer;font-size: 13px;">Qty</label>
                </th>
                <td mat-cell *matCellDef="let element" style="text-align: right; padding-right: 11px;"> {{element.strQty}} </td>
              </ng-container>    

              <tr mat-header-row *matHeaderRowDef="storeDisplayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: storeDisplayedColumns;"></tr>
            </table>
        </div>
      </div>

      <!-- Batch Table -->
      <div *ngIf="isBatchEnabled" id="batchDiv" class="pad0 bzMatTbl" style="margin-top: 15px; padding: 15px; width: 60%;">
          <div class="col-md-12 col-sm-12 col-xs-12 disFlx pad0">
              <div class="col-md-6 col-sm-6 col-xs-6 pad0">
                  <span class="lblHeader newHeader" style="font-size: 20px !important;">Batches ({{batchDataSource.data.length}})</span>
              </div>   
          </div>
          <div *ngIf="batchDataSource.data.length == 0" class="col-md-12 col-sm-12 col-xs-12 pad0" style="padding: 10px 0px 0px 0px;">
            <span class="infoBadge" style="font-size: 13px !important; display: inline-flex; background-color: #f1f1f0; border: none; color: inherit; padding: 6px; border-radius: 3px;">No Batches Found</span>
          </div>
          <div class="batchTable" *ngIf="batchDataSource.data.length > 0">
              <table #batchSort = "matSort" mat-table [dataSource]="batchDataSource" matSort style="border-radius: 3px; padding-left: 16px !important; padding: 0px;">
                <ng-container matColumnDef="B">
                  <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header style="padding-top: 10px; padding-bottom: 5px;">
                    <label style="font-size: 13px;">Batch</label>
                  </th>
                  <td mat-cell *matCellDef="let element"> {{element.B ? element.B : '-'}} </td>
                </ng-container>
      
                <ng-container matColumnDef="Q">
                  <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                      style="text-align: right; font-size: 13px; cursor: pointer; padding-left: 8px; padding-top: 10px; padding-bottom: 5px;">
                      <label style="cursor: pointer;font-size: 13px;">Qty</label>
                  </th>
                  <td mat-cell *matCellDef="let element">
                      <div style="text-align: right; padding-right: 11px;">
                        {{element.Q > 0 ? element.Q : '0'}} </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="C">
                  <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                      style="text-align: right; font-size: 13px; cursor: pointer; padding-left: 8px; padding-top: 10px; padding-bottom: 5px;">
                      <label style="cursor: pointer;font-size: 13px;">Entry</label>
                  </th>
                  <td mat-cell *matCellDef="let element">
                      <div style="padding-right: 11px;">
                        {{element.C ? (element.C | todayTommorow) : '-'}} </div>
                  </td>
                </ng-container>
      
                <ng-container matColumnDef="E">
                  <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                      style="text-align: right; font-size: 13px; cursor: pointer; padding-left: 8px; padding-top: 10px; padding-bottom: 5px;">
                      <label style="cursor: pointer;font-size: 13px;">Expiry</label>
                  </th>
                  <td mat-cell *matCellDef="let element">
                      <div style="padding-right: 11px;">
                        {{element.E ? (element.E | todayTommorow) : '-'}} </div>
                  </td>
                </ng-container>
            
                <tr mat-header-row *matHeaderRowDef="batchDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: batchDisplayedColumns;"></tr>
              </table>
          </div>
      </div>
    </div>
</div>

<div class="container-fluid mobView bggray" style="padding: 10px; margin-bottom: 15px;">
  <div class="row">
      <!-- Header -->
      <div class="col-12 pad0 padHeder" style="padding-bottom: 0px;">
          <div class="col-12 pad0 inLneBlk">
            <h4 style="font-size: 30px; margin: 0;" class="newHeader">{{itemSummaryData.ItemName}}</h4>
          </div>
      </div>
      <!-- Item Details Block -->
      <div class="col-12 disFlx pad0" style="margin-top: 10px; column-gap: 8px; row-gap: 10px; flex-wrap: wrap;">
        <span class="orngLabel" *ngIf="itemSummaryData.categoryName != ''">
            Category  <span style="font-weight: 600;">{{itemSummaryData.categoryName}}</span>
        </span>
        <span class="orngLabel" *ngIf="itemSummaryData.subCategoryName != ''">
            Subcategory  <span style="font-weight: 600;">{{itemSummaryData.subCategoryName}}</span>
        </span>
        <span class="orngLabel">
            Min Qty.  <span style="font-weight: 600;">{{itemSummaryData.MinStockQty}} {{itemSummaryData.SKU}}</span>
        </span>
        <span class="orngLabel">
            Lead Time <span style="font-weight: 600;">{{itemSummaryData.LeadTime}} {{itemSummaryData.LeadTime == 1 ? 'day' : 'days'}}</span>
        </span>
      </div>
      <!-- Scroll buttons -->
      <div *ngIf="show.scrollBtns" class="col-12 disFlx pad0" style="flex-wrap: wrap; column-gap: 8px; row-gap: 10px; margin-top: 10px;">
        <span class="btn orangeButton fontSizeHead" style=" font-size: 13px !important; cursor: pointer; border-radius: 3px;" (click)="scrollToDiv('soblock')">
            SO
        </span>
        <span class="btn orangeButton fontSizeHead" style=" font-size: 13px !important; cursor: pointer; border-radius: 3px;" (click)="scrollToDiv('poblock')">
            PO
        </span>
        <span class="btn orangeButton fontSizeHead" style=" font-size: 13px !important; cursor: pointer; border-radius: 3px;" (click)="scrollToDiv('jobblock')">
            Job
        </span>
        <span class="btn orangeButton fontSizeHead" style=" font-size: 13px !important; cursor: pointer; border-radius: 3px;" (click)="scrollToDiv('storeblock')">
            Stores
        </span>
        <span *ngIf="isBatchEnabled" class="btn orangeButton fontSizeHead" style=" font-size: 13px !important; cursor: pointer; border-radius: 3px;" (click)="scrollToDiv('batchesblock')">
            Batches
        </span>
      </div>

      <!-- Sales Orders -->
      <div id="soblock" class="col-md-12 col-sm-12 col-xs-12 pad0 bzMatTbl" style="margin-top: 15px;">
        <div class="col-md-12 col-sm-12 col-xs-12 disFlx pad0" style="padding: 10px;">
          <div class="col-8 pad0">
              <span class="lblHeader newHeader" style="font-size: 16px !important;">
                Sales Orders <span *ngIf="userRights.SOViewTypeID > 0">({{soDataSource.data.length}})</span>
              </span>
          </div>
          <div *ngIf="userRights.SOViewTypeID > 0" class="col-4 pad0" style="text-align: end;">
            <a class="btn orangeButton fontSizeHead" href="/main.html#/orders" target="{{isWeb ? '_blank' : '_self'}}" style="font-size: 13px !important; cursor: pointer; border-radius: 3px; margin-left: 5px;" title="Manage">
              <span style="vertical-align: middle;"><i class="fa fa-list"></i></span>
            </a>
            <a *ngIf="userRights.SOEntry" class="btn orangeButton fontSizeHead" href="/main.html#/DocBuilder?isN=1&Type=Sales%20Order" target="{{isWeb ? '_blank' : '_self'}}" style="font-size: 13px !important; cursor: pointer; border-radius: 3px; margin-left: 5px;"
              title="Add">
              <i class="zmdi zmdi-plus" style="font-size: 15px; vertical-align: middle;"></i>
            </a>
          </div>            
        </div>
        <!-- SO Cards -->
        <div *ngIf="soDataSource.data.length == 0" class="col-md-12 col-sm-12 col-xs-12 pad0" style="padding: 10px;">
          <span class="infoBadge" style="font-size: 13px !important; display: inline-flex; background-color: #f1f1f0; border: none; color: inherit; padding: 6px; border-radius: 3px;">No Sales Orders Found</span>
        </div>
        <div *ngIf="userRights.SOViewTypeID == 0" class="col-md-12 col-sm-12 col-xs-12 pad0" style="padding: 0px 10px 10px;">
          <span class="infoBadge" style="font-size: 13px !important; display: inline-flex; background-color: #f1f1f0; border: none; color: inherit; padding: 6px; border-radius: 3px;">Please contact your system administrator to upgrade your account.</span>
        </div>
        <div *ngIf="userRights.SOViewTypeID > 0">
          <div *ngFor="let d of soDataSource.data; let i = index" [style.backgroundColor]="i % 2 == 0 ? '#f5f5f5' : '#fff'">
            <div class="col-12 disFlx" style="padding: 10px; cursor: pointer;">
              <!-- left -->
              <div class="col-8" style="padding-left: 0px; display: inline-block; white-space: nowrap; overflow: hidden;text-overflow: ellipsis; font-weight: bold;">
                  <div style="display: block;">
                      <span style="margin-top: 5px; color: #777; font-size: 12px;font-weight: bold;">
                          #{{d.OrderNo}}
                      </span>
                      <b style="font-size: 16px;"> | </b>
                      <span class="btn padLeft5 hvrInfo pad0" style="font-size: 12px; color: #4caf50; box-shadow: none; line-height: 20px;">
                          <i class="fa fa-calendar" aria-hidden="true"></i> {{d.OrderDate | todayTommorow}}
                      </span>
                  </div>                
                  <div class="mrg0">
                      <span ng-if="d.BuyerCompName" style="font-size: 12px; color: #2b7fb3; box-shadow: none;">
                          <i class="zmdi zmdi-account"></i>
                          {{d.BuyerCompName}}
                      </span>
                  </div>
              </div>
              <!-- right -->
              <div class="col-4 pad0" style="text-align: right;">
                <div style="font-size: 12px; margin: 0px !important; padding: 0px 7px; margin-top: 5px !important;">
                  <b> {{d.OrderQty}} {{d.SKU}} </b>
                </div>
                <div ng-show="d.GrandTotal != 0" style="font-size: 12px; margin: 0px !important; padding: 0px 7px; margin-top: 5px !important;">
                  <b> ₹ {{d.GrandTotal}} </b>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Purchase Orders -->
      <div id="poblock" class="col-md-12 col-sm-12 col-xs-12 pad0 bzMatTbl" style="margin-top: 15px;">
        <div class="col-md-12 col-sm-12 col-xs-12 disFlx pad0" style="padding: 10px;">
          <div class="col-8 pad0">
              <span class="lblHeader newHeader" style="font-size: 16px !important;">
                Purchase Orders <span *ngIf="userRights.POView">({{poDataSource.data.length}})</span>
              </span>
          </div>
          <div *ngIf="userRights.POView" class="col-4 pad0" style="text-align: end;">
            <a class="btn orangeButton fontSizeHead" href="/main.html#/Docs?M=8" target="{{isWeb ? '_blank' : '_self'}}" style="font-size: 13px !important; cursor: pointer; border-radius: 3px; margin-left: 5px;" title="Manage">
              <span style="vertical-align: middle;"><i class="fa fa-list"></i></span>
            </a>
            <a *ngIf="userRights.POEntry" class="btn orangeButton fontSizeHead" href="/main.html#/DocBuilder?isN=1&Type=Purchase%20Order" target="{{isWeb ? '_blank' : '_self'}}" style="font-size: 13px !important; cursor: pointer; border-radius: 3px; margin-left: 5px;" title="Add">
              <i class="zmdi zmdi-plus" style="font-size: 15px; vertical-align: middle;"></i>
            </a>
          </div>            
        </div>
        <!-- PO Cards --> 
        <div *ngIf="poDataSource.data.length == 0 && userRights.POView" class="col-md-12 col-sm-12 col-xs-12 pad0" style="padding: 10px;">
          <span class="infoBadge" style="font-size: 13px !important; display: inline-flex; background-color: #f1f1f0; border: none; color: inherit; padding: 6px; border-radius: 3px;">No Purchase Orders Found</span>
        </div>
        <div *ngIf="!userRights.POView" class="col-md-12 col-sm-12 col-xs-12 pad0" style="padding: 0px 10px 10px;">
          <span class="infoBadge" style="font-size: 13px !important; display: inline-flex; background-color: #f1f1f0; border: none; color: inherit; padding: 6px; border-radius: 3px;">Please contact your system administrator to upgrade your account.</span>
        </div>
        <div *ngIf="userRights.POView">
          <div *ngFor="let d of poDataSource.data; let i = index" [style.backgroundColor]="i % 2 == 0 ? '#f5f5f5' : '#fff'">
            <div class="col-12 disFlx" style="padding: 10px; cursor: pointer;">
              <!-- left -->
              <div class="col-8" style="padding-left: 0px; display: inline-block; white-space: nowrap; overflow: hidden;text-overflow: ellipsis; font-weight: bold;">
                  <div style="display: block;">
                      <span style="margin-top: 5px; color: #777; font-size: 12px;font-weight: bold;">
                          #{{d.DocNo}}
                      </span>
                      <b style="font-size: 16px;"> | </b>
                      <span class="btn padLeft5 hvrInfo pad0" style="font-size: 12px; color: #4caf50; box-shadow: none; line-height: 20px;">
                          <i class="fa fa-calendar" aria-hidden="true"></i> {{d.DocDate | todayTommorow}}
                      </span>
                  </div>                
                  <div class="mrg0">
                      <span ng-if="d.BuyerCompName" style="font-size: 12px; color: #2b7fb3; box-shadow: none;">
                          <i class="zmdi zmdi-account"></i>
                          {{d.SellerAgencyName}}
                      </span>
                  </div>
              </div>
              <!-- right -->
              <div class="col-4 pad0" style="text-align: right;">
                <div style="font-size: 12px; margin: 0px !important; padding: 0px 7px; margin-top: 5px !important;">
                  <b> {{d.ItemQty}} {{d.SKU}} </b>
                </div>
                <div ng-show="d.GrandTotal != 0" style="font-size: 12px; margin: 0px !important; padding: 0px 7px; margin-top: 5px !important;">
                  <b> ₹ {{d.GrandTotal}} </b>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Jobs -->
      <div id="jobblock" class="col-md-12 col-sm-12 col-xs-12 pad0 bzMatTbl" style="margin-top: 15px;">
        <div class="col-md-12 col-sm-12 col-xs-12 disFlx pad0" style="padding: 10px;">
          <div class="col-8 pad0">
              <span class="lblHeader newHeader" style="font-size: 16px !important;">
                Production Jobs <span *ngIf="userRights.JobView">({{jobDataSource.data.length}})</span>
              </span>
          </div>
          <div *ngIf="userRights.JobView" class="col-4 pad0" style="text-align: end;">
            <a class="btn orangeButton fontSizeHead" href="/ERP/ProductionList?p=1" target="{{isWeb ? '_blank' : '_self'}}" style="font-size: 13px !important; cursor: pointer; border-radius: 3px; margin-left: 5px;" title="Manage">
              <span style="vertical-align: middle;"><i class="fa fa-list"></i></span>
            </a>
            <a class="btn orangeButton fontSizeHead" href="/ERP/ProductionList?p=1" target="{{isWeb ? '_blank' : '_self'}}" style="font-size: 13px !important; cursor: pointer; border-radius: 3px; margin-left: 5px;" title="Add">
              <i class="zmdi zmdi-plus" style="font-size: 15px; vertical-align: middle;"></i>
            </a>
          </div>            
        </div>
        <!-- PO Cards -->
        <div *ngIf="jobDataSource.data.length == 0 && userRights.JobView" class="col-md-12 col-sm-12 col-xs-12 pad0" style="padding: 10px;">
          <span class="infoBadge" style="font-size: 13px !important; display: inline-flex; background-color: #f1f1f0; border: none; color: inherit; padding: 6px; border-radius: 3px;">No Production Jobs Found</span>
        </div>
        <div *ngIf="!userRights.JobView" class="col-md-12 col-sm-12 col-xs-12 pad0" style="padding: 0px 10px 10px;">
          <span class="infoBadge" style="font-size: 13px !important; display: inline-flex; background-color: #f1f1f0; border: none; color: inherit; padding: 6px; border-radius: 3px;">Please contact your system administrator to upgrade your account.</span>
        </div>
        <div *ngIf="userRights.JobView">
          <div *ngFor="let d of jobDataSource.data; let i = index" [style.backgroundColor]="i % 2 == 0 ? '#f5f5f5' : '#fff'">
            <div class="col-12 disFlx" style="padding: 10px; cursor: pointer;">
              <!-- left -->
              <div class="col-8" style="padding-left: 0px; display: inline-block; white-space: nowrap; overflow: hidden;text-overflow: ellipsis; font-weight: bold;">
                  <div style="display: block;">
                      <span style="margin-top: 5px; color: #777; font-size: 12px;font-weight: bold;">
                          #{{d.JobNo}}
                      </span>
                      <b style="font-size: 16px;"> | </b>
                      <span class="btn padLeft5 hvrInfo pad0" style="font-size: 12px; color: #4caf50; box-shadow: none; line-height: 20px;">
                          <i class="fa fa-calendar" aria-hidden="true"></i> {{d.LaunchDT | todayTommorow}}
                      </span>
                  </div>                
                  <div class="mrg0" style="height: 24px;">
                      <span *ngIf="d.CstrRelName && d.CstrRelName != ''" style="font-size: 12px; color: #2b7fb3; box-shadow: none;">
                          <i class="zmdi zmdi-account"></i>
                          {{d.CstrRelName}}
                      </span>
                  </div>
              </div>
              <!-- right -->
              <div class="col-4 pad0" style="text-align: right;">
                <div style="font-size: 12px; margin: 0px !important; padding: 0px 7px; margin-top: 5px !important;">
                  <b> {{d.PndgQty}} {{itemSummaryData.SKU}} </b>
                </div>
                <div style="font-size: 12px; margin: 0px !important; padding: 0px 7px; margin-top: 5px !important;">
                  <b> {{d.Stage == '' ? 'Not Started' : d.Stage}} </b>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Stores -->
      <div id="storeblock" class="col-md-12 col-sm-12 col-xs-12 pad0 bzMatTbl" style="margin-top: 15px;">
        <div class="col-md-12 col-sm-12 col-xs-12 disFlx pad0" style="padding: 10px;">
          <div class="col-md-8 col-sm-8 col-xs-8 pad0">
              <span class="lblHeader newHeader" style="font-size: 16px !important;">
                Stores <span *ngIf="allStoreRights">({{storeDataSource.data.length}})</span>
              </span>
          </div>         
        </div>
        <!-- Store Cards -->
        <div *ngIf="storeDataSource.data.length == 0 && allStoreRights" class="col-md-12 col-sm-12 col-xs-12 pad0" style="padding: 10px;">
          <span class="infoBadge" style="font-size: 13px !important; display: inline-flex; background-color: #f1f1f0; border: none; color: inherit; padding: 6px; border-radius: 3px;">No Stores Found</span>
        </div>
        <div *ngIf="!allStoreRights" class="col-md-12 col-sm-12 col-xs-12 pad0" style="padding: 0px 10px 10px;">
          <span class="infoBadge" style="font-size: 13px !important; display: inline-flex; background-color: #f1f1f0; border: none; color: inherit; padding: 6px; border-radius: 3px;">Please contact your system administrator to upgrade your account.</span>
        </div>
        <div *ngIf="allStoreRights">
          <div *ngFor="let d of storeDataSource.data; let i = index" [style.backgroundColor]="i % 2 == 0 ? '#f5f5f5' : '#fff'">
            <div class="col-12 disFlx" style="padding: 10px; cursor: pointer;">
              <!-- left -->
              <div class="col-8" style="padding-left: 0px; display: inline-block; white-space: nowrap; overflow: hidden;text-overflow: ellipsis; font-weight: bold;">
                  <div style="display: block;">
                      <span style="margin-top: 5px; font-size: 12px;font-weight: bold;">
                          {{d.strName}}
                      </span>
                  </div>
              </div>
              <!-- right -->
              <div class="col-4 pad0" style="text-align: right;">
                <div style="font-size: 12px; margin: 0px !important; padding: 0px 7px; margin-top: 5px !important;">
                  <b> {{d.strQty}} {{d.itemUnit}} </b>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Batches -->
      <div *ngIf="isBatchEnabled" id="batchesblock" class="col-md-12 col-sm-12 col-xs-12 pad0 bzMatTbl" style="margin-top: 15px;">
        <div class="col-md-12 col-sm-12 col-xs-12 disFlx pad0" style="padding: 10px;">
          <div class="col-md-8 col-sm-8 col-xs-8 pad0">
              <span class="lblHeader newHeader" style="font-size: 16px !important;">Batches ({{batchDataSource.data.length}})</span>
          </div>         
        </div>
        <!-- Store Cards -->
        <div *ngIf="batchDataSource.data.length == 0" class="col-md-12 col-sm-12 col-xs-12 pad0" style="padding: 10px;">
          <span class="infoBadge" style="font-size: 13px !important; display: inline-flex; background-color: #f1f1f0; border: none; color: inherit; padding: 6px; border-radius: 3px;">No Batches Found</span>
        </div>
        <div *ngFor="let batch of batchDataSource.data; let i = index" [style.backgroundColor]="i % 2 == 0 ? '#f5f5f5' : '#fff'">
          <div class="col-12 disFlx" style="padding: 10px; cursor: pointer;">
            <!-- left -->
            <div class="col-6" style="padding-left: 0px; display: inline-block; white-space: nowrap; overflow: hidden;text-overflow: ellipsis; font-weight: bold;">
                <div style="display: block;">
                  <span style="margin-top: 5px; font-size: 12px; font-weight: bold;">
                    {{batch.B}}
                  </span>
                </div>
                <div style="display: block;">
                  <span style="margin-top: 5px; font-size: 12px ;font-weight: bold; color: #4caf50;">
                    Entry : {{batch.C | todayTommorow}}
                  </span>
                </div>
            </div>
            <!-- right -->
            <div class="col-6 pad0" style="text-align: right; font-weight: bold;">
              <div style="font-size: 12px; margin: 0px !important; padding: 0px 7px; margin-top: 5px !important;">
                {{batch.Q}} {{itemSummaryData.SKU}}
              </div>
              <div style="font-size: 12px; margin: 0px !important; padding: 0px 7px; margin-top: 5px !important; color: #FF0000;">
                Expiry : {{batch.E | todayTommorow}}
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</div>  